import './footer.css';
import React from 'react';
import { BsLinkedin } from 'react-icons/bs';
import { FaGithub } from 'react-icons/fa';
import { AiOutlineTwitter } from 'react-icons/ai';
import {IoLogoWhatsapp} from 'react-icons/io'

export default function Footer() {
  return (
    <footer>
      <a href='#' className='footer__logo'>
        Rigers Allaraj
      </a>
      <ul className='permalinks'>
        <li><a href='#'>Home</a></li>
        <li><a href='#about'>About</a></li>
        <li><a href='#experience'>Experience</a></li>
        <li><a href='#services'>Services</a></li>
        <li><a href='#portfolio'>Portfolio</a></li>
        {/* <li><a href='#testimonials'>Testimonials</a></li> */}
        <li><a href='#contact'>Contact</a></li>
      </ul>

      <div className="footer__socials">
      <a href='https://al.linkedin.com/in/rigers-allaraj-5bb234160' title='LinkedIn' target='_blank' className='btn-animation-footer'>
        <BsLinkedin/>
      </a>
      <a href='https://github.com/rigers-allaraj' title='Github' target='_blank' className='btn-animation-footer'>
        <FaGithub/>
      </a>
      <a href='https://api.whatsapp.com/send?phone=355684818539' title='Whatsapp' target='_blank' className='btn-animation-footer'>
        <IoLogoWhatsapp/>
      </a>
      </div>
      <div className="footer__copyright">
        <small>&copy; Rigers Allaraj.   All right reserved</small>
      </div>
    </footer>
  );
}

